import { useMemo, FC } from 'react'
import NextLink from 'next/link'
import Image from 'next/image'
import { useRouter } from 'next/router'
import { buildContactUsHref } from '../../common/contact-us-link'

export interface FloatRobotProps {
  robot: string
  color: string
  hideCircleBorder?: boolean
  href?: string
  buttonText?: string
  buttonTextColor?: string
  buttonTextSize?: 'small' | 'default' | 'large'
}

const FloatRobot: FC<FloatRobotProps> = ({
  robot,
  color,
  hideCircleBorder,
  href,
  buttonText = 'Contact Us',
  buttonTextSize: buttonSize = 'default',
  buttonTextColor = '#fff',
}) => {
  const defaultSize = 'w-35'
  // const widthSizeMap = { 'default': defaultSize, 'large': 'w-40' }
  // const widthSize = widthSizeMap[size] ?? defaultSize
  const buttonTextSizeMap = {
    small: 'text-sm',
    default: 'text-18',
    large: 'text-lg',
  }
  const buttonTextSizeClassName = buttonTextSizeMap[buttonSize] ?? buttonTextSizeMap['default']
  const router = useRouter()
  const { robot: robotQs } = router.query as { robot: string }
  const link = useMemo(() => {
    if (href) return href
    return buildContactUsHref(robotQs)
  }, [href, robotQs])

  return (
    <div
      style={{ zIndex: 100 }}
      className={[
        defaultSize,
        'fixed -right-16px laptop:right-78px bottom-32px laptop:bottom-78px h-35 scale-50 laptop:scale-100',
      ].join(' ')}
    >
      <NextLink href={link}>
        <div
          className={[
            'absolute left-2 top-10px w-31 h-31 rounded-full border-solid overflow-hidden',
            hideCircleBorder ? 'border-0' : 'border-2',
          ].join(' ')}
          style={{ borderColor: color }}
        >
          <Image
            alt="robot"
            src={robot}
            layout="fill"
            objectFit="cover"
            className="event-trigger"
            data-event-key="event"
            data-event-value="initiate_lead"
          />
        </div>
      </NextLink>
      <NextLink href={link}>
        <button
          className={[
            'event-trigger absolute rounded-lg bottom-0 left-0 right-0 py-2 font-semibold',
            buttonTextSizeClassName,
          ].join(' ')}
          style={{ backgroundColor: color, color: buttonTextColor }}
          data-event-key="event"
          data-event-value="initiate_lead"
        >
          {buttonText}
        </button>
      </NextLink>
    </div>
  )
}

export default FloatRobot
